import React from 'react';

import Tasks from './tasks/Tasks';

const MainPage = () => {
  return (
    <div className="main-page">
      <Tasks />
    </div>
  );
};
export default MainPage;
